// config/config.ts - Updated secure client configuration
const CONFIG = {
  // App Configuration (public)
  MAIN_URL: process.env.REACT_APP_URL || process.env.MAIN_URL || 'http://localhost:3000',

  // Public Keys (designed to be public)
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || process.env.STRIPE_PUBLISHABLE_KEY,

  // Firebase Configuration (public by design)
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY || process.env.FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || process.env.FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID || process.env.FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || process.env.FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || process.env.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID || process.env.FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || process.env.FIREBASE_MEASUREMENT_ID,

  // Public IDs (not sensitive)
  FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || process.env.FACEBOOK_APP_ID,
  SOOPRA_NEWS_ID: process.env.REACT_APP_SOOPRA_NEWS_ID || process.env.SOOPRA_NEWS_ID,

  // Analytics & Monitoring (public)
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || process.env.SENTRY_DSN,
  NIELSEN_DATA: process.env.REACT_APP_NIELSEN_DATA || process.env.NIELSEN_DATA,

  // Development flags (public)
  FIREBASE_API_VERSION: process.env.REACT_APP_FIREBASE_API_VERSION || process.env.FIREBASE_API_VERSION,

  // Google Client ID (public by design)
  MEETH_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || process.env.MEETH_GOOGLE_CLIENT_ID,

  // DEPRECATED: These should NO LONGER be used in client-side code
  // They're kept here temporarily for backward compatibility during migration
  // TODO: Remove these after confirming all usage has moved to proxy functions
  // API_END_POINT: process.env.REACT_APP_API_END_POINT || process.env.API_END_POINT,
  // API_GPU_END_POINT: process.env.REACT_APP_API_GPU_END_POINT || process.env.API_GPU_END_POINT,
  // API_REQUEST_ACCESS_TOKEN: process.env.REACT_APP_API_REQUEST_ACCESS_TOKEN || process.env.API_REQUEST_ACCESS_TOKEN,
  // API_INTERNAL_ACCESS_TOKEN: process.env.REACT_APP_API_INTERNAL_ACCESS_TOKEN || process.env.API_INTERNAL_ACCESS_TOKEN,
  // UNSPLASH_ACCESS_KEY: process.env.REACT_APP_UNSPLASH_ACCESS_KEY || process.env.UNSPLASH_ACCESS_KEY,
  // FRANK_GOOGLE_SHEET_URL: process.env.REACT_APP_GOOGLE_SHEET_URL || process.env.FRANK_GOOGLE_SHEET_URL,
  // OPENAI_STT_KEY: process.env.REACT_APP_OPENAI_STT_KEY || process.env.OPENAI_STT_KEY,
  // TAVUS_API_KEY: process.env.REACT_APP_TAVUS_API_KEY || process.env.TAVUS_API_KEY,
  // ABLY_API_KEY: process.env.REACT_APP_ABLY_API_KEY || process.env.ABLY_API_KEY,
  // MEETH_GOOGLE_CLIENT_SECRET: process.env.REACT_APP_GOOGLE_CLIENT_SECRET || process.env.MEETH_GOOGLE_CLIENT_SECRET,
}

Object.freeze(CONFIG);

export default CONFIG;
